var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.options
    ? _c("quill-editor", {
        ref: "myQuillEditor",
        attrs: { options: _vm.options },
        on: {
          blur: function ($event) {
            return _vm.onEditorBlur($event)
          },
          focus: function ($event) {
            return _vm.onEditorFocus($event)
          },
          ready: function ($event) {
            return _vm.onEditorReady($event)
          },
          change: _vm.onEditorChange,
        },
        model: {
          value: _vm._value,
          callback: function ($$v) {
            _vm._value = $$v
          },
          expression: "_value",
        },
      })
    : _c("quill-editor", {
        ref: "myQuillEditor",
        on: {
          blur: function ($event) {
            return _vm.onEditorBlur($event)
          },
          focus: function ($event) {
            return _vm.onEditorFocus($event)
          },
          ready: function ($event) {
            return _vm.onEditorReady($event)
          },
          change: _vm.onEditorChange,
        },
        model: {
          value: _vm._value,
          callback: function ($$v) {
            _vm._value = $$v
          },
          expression: "_value",
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }